module.exports = __webpack_public_path__ + "images/593d5575b223a7414a3b373223bb47e1976203a909e0aa6c3597a715042ace18.svg";